module.exports = __webpack_public_path__ + "faq/img/clear-cache.4f85ac34.png";